// // src/pages/gallery/DocumentFormModal.jsx
// import { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Stack,
//   Typography,
//   IconButton,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import { toast } from "react-toastify";
// import { saveDocumentAPI } from "../../api/documentApi";
// import { uploadProductImage } from "../../api/productApi";

// export default function DocumentFormModal({ open, onClose, onSaved, initialData }) {
//   const [form, setForm] = useState({
//     trId: 0,
//     documentName: "",
//     documentUrl: "",
//     status: "Active", 
//     addedBy: "Admin", 
//     updatedBy: "Admin", 
//   });
//   const [filePreview, setFilePreview] = useState("");
//   const [uploading, setUploading] = useState(false);

//   useEffect(() => {
//     if (initialData) {
//       setForm((prev) => ({
//         ...prev,
//         trId: initialData.trId ?? 0,
//         documentName: initialData.documentName ?? initialData.document_name ?? "",
//         documentUrl: initialData.documentUrl ?? initialData.document_url ?? "",
//         status: initialData.status ?? "Active",
//         addedBy: initialData.addedBy ?? initialData.added_by ?? prev.addedBy,
//         updatedBy: initialData.updatedBy ?? initialData.updated_by ?? "",
//       }));
//       setFilePreview(initialData.documentUrl ?? initialData.document_url ?? "");
//     } else {
//       setForm({
//         trId: 0,
//         documentName: "",
//         documentUrl: "",
//         status: "Active",
//         addedBy: "Admin",
//         updatedBy: "Admin",
//       });
//       setFilePreview("");
//     }
//   }, [initialData, open]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((p) => ({ ...p, [name]: value }));
//   };

//   const handleFileSelect = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     // Preview
//     setFilePreview(URL.createObjectURL(file));

//     // Upload
//     setUploading(true);
//     try {
//       const res = await uploadProductImage(file);
//       if (res?.imageName) {
//         setForm((p) => ({ ...p, documentUrl: res.imageName }));
//         toast.success("File uploaded: " + res.imageName);
//       } else {
//         toast.error("Upload failed: server did not return imageName");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Upload failed");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const validate = () => {
//     if (!form.documentName?.trim()) {
//       toast.error("Document name is required");
//       return false;
//     }
//     if (!form.documentUrl?.trim()) {
//       toast.error("Please upload a file");
//       return false;
//     }
//     return true;
//   };

//   const handleSave = async () => {
//     if (!validate()) return;

//     const payload = {
//       trId: form.trId || 0,
//       documentName: form.documentName,
//       documentUrl: form.documentUrl,
//       status: form.status, 
//       addedBy: form.addedBy || "Admin",
//       updatedBy: form.updatedBy || "Admin",
//     };

//     try {
//       await saveDocumentAPI(payload);
// +     toast.success(payload.trId === 0 ? "Document created" : "Document updated");
//       onSaved?.();
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to save document");
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//         {form.trId === 0 ? "Add Document" : "Edit Document"}
//         <IconButton onClick={onClose}>
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent dividers>
//         <Stack spacing={2}>
//           <TextField
//             label="Document Name"
//             name="documentName"
//             value={form.documentName}
//             onChange={handleChange}
//             fullWidth
//             required
//           />

//           <Stack direction="row" spacing={2} alignItems="center">
//             <Button variant="outlined" component="label" startIcon={<UploadFileIcon />}>
//               {uploading ? "Uploading..." : "Select File"}
//               <input type="file" hidden onChange={handleFileSelect} />
//             </Button>

//             {form.documentUrl && (
//               <Button
//                 variant="contained"
//                 onClick={() => window.open(form.documentUrl, "_blank")}
//                 size="small"
//               >
//                 Open Uploaded File
//               </Button>
//             )}
//           </Stack>

//           {filePreview && (
//             <Stack spacing={1}>
//               <Typography variant="subtitle2">Preview</Typography>
//               {/\.(png|jpg|jpeg|webp|gif|svg)$/i.test(filePreview) ? (
//                 <img src={filePreview} alt="preview" style={{ width: 200, height: "auto", borderRadius: 4 }} />
//               ) : /\.(pdf)$/i.test(filePreview) ? (
//                 <iframe src={filePreview} title="preview" style={{ width: "100%", height: 300, border: "none" }} />
//               ) : (
//                 <Typography variant="body2">{form.documentUrl}</Typography>
//               )}
//             </Stack>
//           )}
//         </Stack>
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={onClose}>Cancel</Button>
//         <Button variant="contained" onClick={handleSave}>
//           {form.trId === 0 ? "Create" : "Update"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }




// src/pages/gallery/DocumentFormModal.jsx
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
  IconButton,
  Switch,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { toast } from "react-toastify";
import { saveDocumentAPI } from "../../api/documentApi";
import { uploadProductImage } from "../../api/productApi";

export default function DocumentFormModal({ open, onClose, onSaved, initialData }) {
  const [form, setForm] = useState({
    trId: 0,
    documentName: "",
    documentUrl: "",
    status: "Active", 
    addedBy: "Admin", 
    updatedBy: "Admin", 
  });
  const [filePreview, setFilePreview] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setForm((prev) => ({
        ...prev,
        trId: initialData.trId ?? 0,
        documentName: initialData.documentName ?? initialData.document_name ?? "",
        documentUrl: initialData.documentUrl ?? initialData.document_url ?? "",
        status: initialData.status ?? "Active",
        addedBy: initialData.addedBy ?? initialData.added_by ?? prev.addedBy,
        updatedBy: initialData.updatedBy ?? initialData.updated_by ?? "",
      }));
      setFilePreview(initialData.documentUrl ?? initialData.document_url ?? "");
    } else {
      setForm({
        trId: 0,
        documentName: "",
        documentUrl: "",
        status: "Active",
        addedBy: "Admin",
        updatedBy: "Admin",
      });
      setFilePreview("");
    }
  }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  };

  const handleStatusToggle = (e) => {
    setForm((p) => ({ ...p, status: e.target.checked ? "Active" : "Inactive" }));
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFilePreview(URL.createObjectURL(file)); // Preview

    setUploading(true);
    try {
      const res = await uploadProductImage(file);
      if (res?.imageName) {
        setForm((p) => ({ ...p, documentUrl: res.imageName }));
        toast.success("File uploaded: " + res.imageName);
      } else {
        toast.error("Upload failed: server did not return imageName");
      }
    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const validate = () => {
    if (!form.documentName?.trim()) {
      toast.error("Document name is required");
      return false;
    }
    if (!form.documentUrl?.trim()) {
      toast.error("Please upload a file");
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validate()) return;

    const payload = {
      trId: form.trId || 0,
      documentName: form.documentName,
      documentUrl: form.documentUrl,
      status: form.status, 
      addedBy: form.addedBy || "Admin",
      updatedBy: form.updatedBy || "Admin",
    };

    try {
      await saveDocumentAPI(payload);
      toast.success(payload.trId === 0 ? "Document created" : "Document updated");
      onSaved?.();
    } catch (err) {
      console.error(err);
      toast.error("Failed to save document");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {form.trId === 0 ? "Add Document" : "Edit Document"}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            label="Document Name"
            name="documentName"
            value={form.documentName}
            onChange={handleChange}
            fullWidth
            required
          />

          <Stack direction="row" spacing={2} alignItems="center">
            <Button variant="outlined" component="label" startIcon={<UploadFileIcon />}>
              {uploading ? "Uploading..." : "Select File"}
              <input type="file" hidden onChange={handleFileSelect} />
            </Button>

            {form.documentUrl && (
              <Button
                variant="contained"
                onClick={() => window.open(form.documentUrl, "_blank")}
                size="small"
              >
                Open Uploaded File
              </Button>
            )}
          </Stack>
          {/* ✅ Active/Inactive Toggle */}
          <FormControlLabel
            control={
              <Switch
                checked={form.status === "Active"}
                onChange={handleStatusToggle}
                color="primary"
              />
            }
            label={form.status}
          />

          {filePreview && (
            <Stack spacing={1}>
              <Typography variant="subtitle2">Preview</Typography>
              {/\.(png|jpg|jpeg|webp|gif|svg)$/i.test(filePreview) ? (
                <img src={filePreview} alt="preview" style={{ width: 200, height: "auto", borderRadius: 4 }} />
              ) : /\.(pdf)$/i.test(filePreview) ? (
                <iframe src={filePreview} title="preview" style={{ width: "100%", height: 300, border: "none" }} />
              ) : (
                <Typography variant="body2">{form.documentUrl}</Typography>
              )}
            </Stack>
          )}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          {form.trId === 0 ? "Create" : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
